import React, {useEffect, useState} from 'react';
import MaterialTable, {MTableToolbar} from '@material-table/core';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import {EmptyList} from "../../../../components/EmptyList";
import {Info} from "@mui/icons-material";
import {isEmpty} from "underscore";
import {blue, green, red} from "@mui/material/colors";
import DocumentNotes from "../../ListDocument/components/DocumentNotes";
import {DOCUMENT_VIEWER_MODES} from "../../../../constants/DOCUMENT_VIEWER_MODES";
import {SECURITY_ROLES} from "../../../../constants/SECURITY_ROLES";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import {Button, Grid} from "@mui/material";
import FolderIcon from '@mui/icons-material/Folder';
import FolderOffIcon from '@mui/icons-material/FolderOff';
import {useDispatch} from "react-redux";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import CoPresentIcon from '@mui/icons-material/CoPresent';

function colorFromSharedStatus(shared) {
  if (typeof (shared) === 'undefined')
    return '#000000';

  if (shared === 'true')
    return '#FF0000';

  return '#228b22';
}

const DocumentDetailsWithLoadMore = props => {
  const {
    classes,
    documents,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    totalDocuments,
    currentPage,
    setCurrentPage,
    documentsUpdated,
    setDocumentsUpdated,
    companySelect,
    onView,
    onSharedUserView,
    searchDocWithFilters,
    viewer,
    role,
  } = props

  const tableRef = React.useRef(null);

  const dispatch = useDispatch();

  const [showNotes, setShowNotes] = useState(false);
  const [documentData, setDocumentData] = useState(null);

  const [filtering, setFiltering] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const sharedStatusList = {
    true: "Shared",
    false: "Not Shared",
  };

  const isUser = role === SECURITY_ROLES.USER || role === SECURITY_ROLES.POWER_USER;
  const isAdmin = role === SECURITY_ROLES.CLOUD_ADMIN || role === SECURITY_ROLES.COMPANY_ADMIN;

  let startPage = 0;

  const loadMoreButton = {
    action: (props) => {
      return ({
        icon: () => {
          return <div className={classes.moreButton}>
            <ReadMoreIcon className={classes.centerAlign}/> {
            loading ? 'Loading...' : ((totalDocuments > documents.length) ? 'Done Loading' : 'Load More')}
          </div>
        },
        tooltip: 'Load More Multimedia',
        disabled: loading ? loading : (totalDocuments > documents.length) ? true : loading,
        onClick: handleLoadMore
      })
    },
    isFreeAction: true,

  };

  let actions = [
    (rowData) => {
      let iconColor = viewer === DOCUMENT_VIEWER_MODES.SELECT ? colorFromSharedStatus(rowData.shared) : '#000000';
      return (
        {
          icon: () => <VisibilityOutlinedIcon style={{color: iconColor}}/>,
          tooltip: 'View',
          onClick: rowClick
        })
    },
    (rowData) => {
      if (rowData.notesCount > 0) {
        return (
          {
            icon: () => <SpeakerNotesIcon/>,
            tooltip: 'Has Document Notes',
            onClick: notesClick
          })
      }
    },
    (rowData) => {
      if (!isEmpty(rowData.metaData)) {
        return (
          {
            icon: () => <Info sx={{color: blue[500]}}/>,
            tooltip: 'Has Additional Info'
          })
      }
    },
    loadMoreButton
  ];

  if (viewer === DOCUMENT_VIEWER_MODES.LIST && (isUser || isAdmin)){
    actions.push(
      {
        action: (rowData) => {
          if (rowData.shared === 'true')
            return ({
              icon: () => (<MeetingRoomIcon style={{color: '#000000'}}/>),
              tooltip: `Virtual Data Rooms for ${rowData.display_name}`,
              onClick: rowSharedUserClick
            });
        }
      }
    );
  }

  if (viewer === DOCUMENT_VIEWER_MODES.SELECT && isUser) {

    // actions.push(
    actions.splice(1,0,
      {
        // icon: 'share',
        icon: () => {
          return <div className={classes.moreButton}>
            <CoPresentIcon className={classes.centerAlign}/> Shared Filter
          </div>
        },
        tooltip: 'Enable Share Filter',
        isFreeAction: true,
        onClick: () => {
          setFiltering(!filtering);
        }
      },
    )
  }


  let columns = [
    {
      title: 'File Name',
      field: 'display_name',
      cellStyle: {
        width: '30%',
        maxWidth: '30%'
      },
      filtering: false,
    }
  ];

  if (companySelect.toLowerCase() === "all companies") {
    columns.push({
      title: 'Company Name',
      field: 'name',
      cellStyle: {
        width: 150,
        maxWidth: 150
      },
      filtering: false,
    })
  }

  columns.push(
    {
      title: 'File type',
      field: 'file_type',
      searchable: false,
      width: 300,
      hidden: true,
      filtering: false,
    },
    {
      title: 'Media Type',
      field: 'classification',
      filtering: false,
    },
    {
      title: 'Section',
      field: 'section',
      filtering: false,
    },
    {
      title: 'Category',
      field: 'category',
      filtering: false,
    },
    {
      type: 'numeric',
      title: 'Version',
      field: 'version',
      filtering: false,
    },
    {
      type: 'numeric',
      title: 'Size',
      field: 'size',
      hidden: true,
      filtering: false,
    },
    {
      type: 'date',
      title: 'File Date',
      field: 'upload_date',
      align: 'right',
      filtering: false,
    }
  );

  if (viewer === DOCUMENT_VIEWER_MODES.SELECT && (isUser || isAdmin)) {
    columns.push(
      {
        type: 'string',
        title: 'Shared',
        field: 'shared',
        lookup: sharedStatusList,
        hidden: !filtering,
      }
    )
  }

  if (viewer === DOCUMENT_VIEWER_MODES.STAGED) {
    columns.push(
      {
        type: 'string',
        title: "Status",
        field: "status",
        filtering: false,
      },
      {
        type: 'string',
        title: "Last Name",
        field: "last_name",
        filtering: false,
      });
  }

  if (role !== "SharedUser") {
    columns.push(
      {
        title: 'Attributes',
        field: 'metaData',
        cellStyle: {
          width: '30%',
          maxWidth: '30%'
        },
        hidden: true,
        filtering: false,
      },
      {
        field: 'shareable',
        title: 'Shareable',
        filtering: false,
        render: document =>
          (document.shareable ? (
            <Button disabled
              title="Shareable"
              value={document.guid}
              aria-label="shareable"
              aria-readonly="true"
            >
              <FolderIcon
                style={{color: green[500]}}
              />
            </Button>
          ) : (
            <Button disabled
              title="Not Shareable"
              value={document.guid}
              aria-label="notShareable"
              aria-readonly="true"
            >
              <FolderOffIcon
                style={{color: red[500]}}
              />
            </Button>
          ))
      }
    )
  }

  const fetchData = async () => {
    try {
      setLoading(true);
      await fetchMoreData(page);
    } finally {
      setLoading(false);
    }
  };

  const fetchMoreData = async (rowPage) => {
    await searchDocWithFilters(documents.length)
      .then(
      docs => {
        startPage = (Math.ceil(docs.length / rowsPerPage) - 1);
        setCurrentPage(startPage);
        setPage(startPage);
      }
    )
  };

  const notesClick = (event, rowData) => {
    event.preventDefault();
    setDocumentData(rowData);
    setShowNotes(true);

  };

  const handleCloseShowNotes = () => {
    setShowNotes(false);
  };

  const handleLoadMore = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.target;
    if (scrollHeight - scrollTop === clientHeight && !loading) {
      fetchData();
    }
  };


  function pageChangeClick(page) {
    setCurrentPage(page);
    setPage(page);
  }


  function rowClick(event, rowData) {
    event.preventDefault();
    onView(rowData);
  }

  function rowSharedUserClick(event, rowData) {
    event.preventDefault();
    onSharedUserView(rowData);
  }


  useEffect(() => {
    const overrideCurrentPage = async (page) => {
      setPage(page);
      if (!tableRef.current) {
        console.log("Error....Data table can't be accessed.")
        return;
      }

      tableRef.current.dataManager.changeCurrentPage(page);
      setDocumentsUpdated(false);
    }

    if (documentsUpdated){
      overrideCurrentPage(currentPage).then(() => {
        // do nothing
      });
    }
    setInitialLoad(false);
  }, [initialLoad, currentPage, documentsUpdated, setPage, setDocumentsUpdated]);

  return (
    <div style={{width: "100%", height: "100%", padding: 0}}>
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: (
              <EmptyList
                label="No Multimedia to Display!"
              />
            ),
          },
        }}
        title=""
        tableRef={tableRef}
        onRowsPerPageChange={(pageSize) => {
          setRowsPerPage(pageSize);
        }}
        columns={columns}
        data={documents}
        options={{
          emptyRowsWhenPaging: false,
          idSynonym: "guid",
          paging: true,
          pageSizeOptions: [5, 10, 20, 30, 50, 100],
          initialPage: 0,
          totalCount: documents.length,
          pageSize: (documents.length > rowsPerPage) ? rowsPerPage : documents.length,
          columnsButton: true,
          filtering: viewer === DOCUMENT_VIEWER_MODES.SELECT ? filtering : false,
          search: true,
          searchFieldAlignment: "left",
          actionsColumnIndex: -1,
          rowStyle: {
            height: '5px'
          }
        }}
        onRowClick={rowClick}
        onPageChange={pageChangeClick}
        actions={actions}
      />
      {showNotes &&
        <DocumentNotes
          showModal={showNotes}
          setShowModal={setShowNotes}
          handleCloseModal={handleCloseShowNotes}
          classes={classes}
          displayName={documentData.display_name}
          pageTitle={(viewer === DOCUMENT_VIEWER_MODES.STAGED) ? 'Notes - Staged Multimedia' : 'Notes - Multimedia'}
          document={documentData}
          view={viewer}
        />
      }
    </div>
  )
}


// const DocumentDetailsWithRouter = withRouter(DocumentDetailsWithLoadMore);

export default DocumentDetailsWithLoadMore;
